import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

// components
import {
  TextInput,
  DatePicker,
  Select,
  YesNo,
} from '../components/inputs';
import { FormRow } from '../components/layout';
import { Collapse } from '../../../common/components';

function Name() {
  const dispatch = useDispatch();
  const {
    gender_identify: genderIdentify,
    self_identify: selfIdentify,
  } = useSelector(store => store.values);
  const genderIdentifyOther = (genderIdentify === '4');
  const selfIdentifyOther = (selfIdentify === '4');

  return (
    <div>
      <FormRow>
        <TextInput
          label="First name"
          name="first_name"
          cols="6"
        />
        <TextInput
          label="Middle Initial"
          name="middle_name"
          cols="4"
        />
      </FormRow>
      <FormRow>
        <TextInput
          label="Last name"
          name="last_name"
          cols="6"
        />
        <DatePicker
          label="DOB"
          name="birthdate"
          cols="6"
        />
      </FormRow>
      <FormRow>
        <Select
          label="Gender"
          name="gender"
          cols="6"
        />
      </FormRow>
      <FormRow>
        <TextInput
          label="Home phone number"
          name="home_phone"
          cols="6"
        />
        <YesNo
          alignBottom
          name="home_phone_type"
          cols="6"
        />
      </FormRow>
      <FormRow>
        <Select
          label="Gender Self Identification"
          name="gender_identify"
          onChangeCallback={(newValue) => {
            if (newValue !== '4') {
              dispatch({ type: 'SET_FIELD_VALUE', name: 'gender_identify_other', value: undefined });
              dispatch({ type: 'SET_FIELD_VALIDATION', name: 'gender_identify_other', value: undefined });
            }
          }}
          cols="6"
        />
        <Select
          label="Sexual Orientation Self Identification"
          name="self_identify"
          onChangeCallback={(newValue) => {
            if (newValue !== '4') {
              dispatch({ type: 'SET_FIELD_VALUE', name: 'self_identify_other', value: undefined });
              dispatch({ type: 'SET_FIELD_VALIDATION', name: 'self_identify_other', value: undefined });
            }
          }}
          cols="6"
        />
      </FormRow>
      <FormRow>
        <div className="col-md-6">
          <Collapse recalculateHeightOnChange={genderIdentifyOther} isOpen={genderIdentifyOther}>
            <TextInput
              name="gender_identify_other"
            />
          </Collapse>
        </div>
        <div className="col-md-6">
          <Collapse recalculateHeightOnChange={selfIdentifyOther} isOpen={selfIdentifyOther}>
            <TextInput
              name="self_identify_other"
            />
          </Collapse>
        </div>
      </FormRow>
    </div>
  );
}

export default Name;
